import { Button, Input, message } from 'antd';
import React, { useState } from 'react';
import PublicService from '../../../../services/publicService';

const UpdatePassword = (props) => {
    const { setShowSuccess, verificationData } = props;
    const [verifyData, setVerifyData] = useState({password: "", repassword: ""});

    const onUpdateChange = (e) => {
        const currentData = { ...verifyData };
        currentData[e.target.name] = e.target.value;
        setVerifyData(currentData);
    };
    const onSignUp = async () => {
        if(!verifyData.repassword || !verifyData.password) {
            message.warning("Please enter both the fields");
        } else if(verifyData.repassword !== verifyData.password){
            message.warning("password and confirm password doesn't match");
        } else {
            const newPassword =  await PublicService.createPassword({
                "email": verificationData.email,
                "email_otp": verificationData.email_otp,
                "password": verifyData.password
            })
            if(newPassword.err){
                message.error(newPassword.msg);
            } else {
                message.success("Successfully updated");
                setShowSuccess(3);
            }

        }

    };
    return <div className="right_item">
        <div className="pubheader_sec">
            <div className="pub_title">Welcome to FoodLuv</div>
            {/* <h3 className="sub_title">Name here</h3> */}
            <div className="logo_sec"><img src="/images/login_icon.png" alt="" /></div>
        </div>
        <div className='w-full'>
            <div className="password_sec w-full">
                <label>Create Password</label>
                <Input className="w-full" name="password" type="password" onChange={onUpdateChange} value={verifyData.password} />
            </div>
            <div className="password_sec w-full">
                <label>Re-enter Password</label>
                <Input className="w-full" type="password" name="repassword" onChange={onUpdateChange} value={verifyData.repassword} />
            </div>
        </div>
        <div className="otp_btns">
            <Button type="primary" className='otp_signup' onClick={onSignUp}>Proceed</Button>
        </div>
    </div>
};
 export default UpdatePassword;